import axios from "axios";
import config from "@/configs/index";

const PRE_URL = config.openHost;

// 获取badgeList
export const fetchBadgeList = (params) => {
  return axios({
    url: PRE_URL + "/v1/phoenix/get_badge_list",
    method: "post",
    data: params,
  });
};

// 设置badge展示
export const postBadgeDisplay = (params) => {
  return axios({
    url: PRE_URL + "/v1/phoenix_admin/config_badge_by_badge_code",
    method: "post",
    data: params,
  });
};

// 加入精选资产
export const postRecommand = (params) => {
  return axios({
    url: PRE_URL + "/v1/phoenix_admin/set_recommand_badges",
    method: "post",
    data: params,
  });
};

// 删除精选资产
export const deleteRecommand = (params) => {
  return axios({
    url: PRE_URL + "/v1/phoenix_admin/delete_recommand_badges",
    method: "post",
    data: params,
  });
};

// 卡包风险提示
export const postRisk = (params) => {
  return axios({
    url: PRE_URL + "/v1/phoenix_admin/set_badge_risk_status",
    method: "post",
    data: params,
  });
};
